import get from 'lodash/get';
import storage from 'shared/helpers/storage';

export const STORAGE_KEY_PINCODE = 'NFEE_PINCODE';

export const getPinCodeToStorage = (): string => {
  return storage.getItem(STORAGE_KEY_PINCODE) || null;
};

export const setPinCodeDataFromStorage = (value: string) => {
  storage.setItem(STORAGE_KEY_PINCODE, value);
};

export const EDIT_TEXT = 'Edit';
export const DEFAULT_TITLE = 'Select Delivery Location';
export const BUTTON_TEXT = 'Apply';
export const DELIVERY_HEADING = 'Select Delivery Location';
export const DELIVERY_TEXT =
  'Enter the pincode of your area to check product availability and delivery options';

export const getPinCodeLabel = (pinCodeResponse: object | null) => {
  const city = get(pinCodeResponse, 'response.city', '');
  const pincode = get(pinCodeResponse, 'pincode', '');

  return `Deliver to ${city} - ${pincode}`;
};

export const getIsServicable = (pinCodeResponse: object | null) => {
  return get(pinCodeResponse, 'response.serviceable', false);
};
